<template>
  <div class="profile-section">
    <div class="section-titles">
      <p
        class="section-title"
        v-html="sectionTitle"
      />
      <p
        v-if="sectionSubtitle"
        class="section-subtitle"
      >
        {{ sectionSubtitle }}
      </p>
    </div>
    <div class="section-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sectionTitle: {
      type: String,
    },
    sectionSubtitle: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
  .profile-section {
    border-top: 1px solid #e1e7ef;
    display: flex;
    @include breakpoint(medium) {
      flex-direction: column;
    }

    .section-titles {
      width: rem-calc(250);
      display: inline-block;
      margin-top: rem-calc(28);

      .section-title {
        color: #2b2b2b;
        line-height: normal;
        margin: 0;
      }

      .section-subtitle {
        color: #989898;
        font-size: rem-calc(12);
        margin: rem-calc(4) 0 0;
      }
    }

    .section-content {
      flex: 1;
      padding: rem-calc(30) 0 rem-calc(28) rem-calc(12);
      font-size: rem-calc(14);
      font-weight: $semi-bold;
      display: flex;
      flex-direction: column;
    }
  }
</style>
